import React from 'react';
import { useForm } from 'react-hook-form';
import CrudEdit from '~/components/CrudEdit';
import IObjectType from '../interfaces/IObjectType';


export default function Edit() {     
  const {register, handleSubmit, control, setValue:setFormValue, getValues} = useForm<IObjectType>();
  const fields = [
      { name: 'id', type: 'hidden'},
      { name: 'name', type: 'string'},
  ];
  
    return(
      <CrudEdit 
        model={'object-type'} 
        fields={fields} 
        register={register} 
        handleSubmit={handleSubmit} 
        control={control} 
        setFormValue={setFormValue}
        messageSuccess={'Object type successfully updated!'}  
        title={'Edit object type'}
        getValues={getValues} 
      />
    )
}
